import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Button,
  Container,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Link, useParams,useHistory} from "react-router-dom";
import { Routes } from "../../routes";
import swal from "sweetalert";
import { postResetPassword } from "../../Service/AllLoginAPI";

export default () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const history = useHistory();
  const { token } = useParams();

  // const submitResetPassword = async (e) => {
  //   try {
  //     e.preventDefault();
  //     const data = {
  //       password: password,
  //       token: token,
  //     };
  //     if (password !== "" && confirmPassword !== "") {
  //       if (password === confirmPassword) {
  //         await postResetPassword(data)
  //           .then((result) => {
  //             console.log("Reset Password Result", result);
  //             swal("Great", "Password updated successfully", "success");
  //             history.push(`${Routes.Signin.path}`);
  //           })
  //           .catch((error) => {
  //             console.log("Reset Password Error", error);
  //             swal("Failed", "Failed to reset password", "error");
  //           });
  //       } else {
  //         swal("Failed", "Passwords does not match", "error");
  //       }
  //     } else if (password !== "") {
  //       swal("Failed", "Please enter password", "error");
  //     } else if (confirmPassword !== "") {
  //       swal("Failed", "Please enter confirm password", "error");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     swal(
  //       "Failed",
  //       "Something went wrong please check your internet",
  //       "error"
  //     );
  //   }
  // };


  //  directly calling api due to avoid token issue during resete password
  
  const submitResetPassword = async (e) => {
    try {
      e.preventDefault();
  
      if (password !== "" && confirmPassword !== "") {
        if (password === confirmPassword) {
          const url = `https://petropulse.petrotec.com/petrotec/resetPassword?password=${encodeURIComponent(password)}&token=${encodeURIComponent(token)}`;
          
          const response = await fetch(url, {
            method: 'POST'
          });
  
          if (response.ok) {
            swal("Great", "Password updated successfully", "success");
            history.push(`${Routes.Signin.path}`);
          } else {
            throw new Error('Failed to reset password');
          }
        } else {
          swal("Failed", "Passwords do not match", "error");
        }
      } else if (password !== "") {
        swal("Failed", "Please enter a password", "error");
      } else if (confirmPassword !== "") {
        swal("Failed", "Please enter confirm password", "error");
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Failed to reset password",
        "error"
      );
    }
  };
  

  return (
    <main>
      <section className="bg-soft d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3 className="signinHead mb-4">Reset Password</h3>
                <Form>
                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Your Password</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group id="confirmPassword" className="mb-4">
                    <Form.Label>Confirm Password</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Confirm Password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={submitResetPassword}
                  >
                    Reset Password
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
